import { render } from "./Tags.vue?vue&type=template&id=6a44a7d3&scoped=true"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"

import "./Tags.vue?vue&type=style&index=0&id=6a44a7d3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a44a7d3"

export default script